module.exports = __webpack_public_path__ + "h5/img/2.47540e0b.jpg";